var generalEventTrackingDispatcher;
export var getGeneralEventTrackingDispatcherInstance = function getGeneralEventTrackingDispatcherInstance() {
  if (!generalEventTrackingDispatcher) {
    generalEventTrackingDispatcher = require('domains/trackingModules/GeneralEventTrackingDispatcher').default; // eslint-disable-line global-require
  }
  return generalEventTrackingDispatcher;
};
export function handlerValidator(target) {
  getGeneralEventTrackingDispatcherInstance();
  if (target instanceof generalEventTrackingDispatcher) {
    return target;
  }
  if (target === undefined) {
    return {
      createMainEventProperties: function createMainEventProperties() {},
      logWithDefaultProps: function logWithDefaultProps() {},
      logWithDefaultEventProps: function logWithDefaultEventProps() {},
      setUserProperties: function setUserProperties() {},
      setDefaultUserProperties: function setDefaultUserProperties() {},
      identify: function identify() {}
    };
  }
  throw new Error("Invalid input passed to handlerValidator: ".concat(JSON.stringify(target)));
}
export function functionValidator(target) {
  if (target instanceof Function) {
    return target;
  }
  throw new Error("Invalid input passed to functionValidator: ".concat(JSON.stringify(target)));
}
export function userValidator(target) {
  if (target && Object.keys(target).includes('login_status')) {
    return target;
  }
  throw new Error("Invalid input passed to userValidator: ".concat(JSON.stringify(target), " must contain login_status"));
}
export function notUndefinedValidator(target) {
  if (target !== null && target !== undefined) {
    return target;
  }
  throw new Error("Invalid input passed to notUndefinedValidator: ".concat(JSON.stringify(target)));
}
var botUserAgents = ['bot', 'googlebot', 'mediapartners-google', 'crawler', 'spider', 'robot', 'crawling'];
var botRegex = RegExp(botUserAgents.join('|'), 'i');
export var isBot = function isBot() {
  return !process.env.SERVER && navigator ? botRegex.test(navigator.userAgent) : false;
};